/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../common/time';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "service": {
            "nested": {
              "NotifyAccountTransferredRequest": {
                "fields": {
                  "merchantToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "transferTime": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "NotifyAccountTransferredResponse": {
                "fields": {}
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.NotifyAccountTransferredRequest && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.NotifyAccountTransferredResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE NotifyAccountTransferredRequest @ squareup/corporate_card/service/notify_account_transferred.proto at 9:1
 */
export const NotifyAccountTransferredRequest = $root.lookupType('squareup.corporate_card.service.NotifyAccountTransferredRequest');
fixType(NotifyAccountTransferredRequest, {
  merchantToken: {
    required: true
  },
  transferTime: {
    required: true
  }
});
Builder.createAndAttachToType(NotifyAccountTransferredRequest);
/**
 * SOURCE NotifyAccountTransferredResponse @ squareup/corporate_card/service/notify_account_transferred.proto at 21:1
 */
export const NotifyAccountTransferredResponse = $root.lookupType('squareup.corporate_card.service.NotifyAccountTransferredResponse');
fixType(NotifyAccountTransferredResponse);
Builder.createAndAttachToType(NotifyAccountTransferredResponse);